import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import { DateObject } from "react-multi-date-picker"

export const DATE_FORMATS = {
    ///to show///
    faDateTime: "HH:mm YYYY/MM/DD",
    faDate: "YYYY/MM/DD",
    faTime: "HH:mm",

    ///to send///
    enDateTime: "YYYY-MM-DD HH:mm:ss",
}

export const addZero = (digit) => {
    if (+digit < 10) digit = "0" + digit;
    return digit

}
export const convertTime = ({ time, type }) => {
    if (type === 'get') {
        let hour = Math.floor(time / 3600);
        let minute = Math.floor((time % 3600) / 60);

        if (hour >= 24) hour = 0;
        return `${addZero(hour)}:${addZero(minute)}`
    } else {
        if (+time.hour === 0 && +time.minute === 0) return 1;
        
        return (+time.hour * 3600) + (+time.minute * 60)
    }
}
export const convertDate = ({ time, format }) => {
    if (time === 'today') time = new Date().setHours(0, 0, 0)

    const faDate = new DateObject({ calendar: persian, locale: persian_fa, date: time })
    const enDate = new DateObject({ date: time })
    const res = { faDate: faDate.format(format), enDate: enDate.format(format) };

    return res
}

